import { jsx } from "react/jsx-runtime";
import { AppointmentPickerDataTestIds } from "../../constants/dataTestIds.js";
import { Wrapper, ArrowIcon } from "./PrevPeriod.styles.js";
import "@mui/icons-material/KeyboardArrowLeft.js";
import "@mui/material";
import "@mui/material/styles";
const PrevPeriod = ({ onClick, disabled }) => /* @__PURE__ */ jsx(
  Wrapper,
  {
    "data-testid": AppointmentPickerDataTestIds.PrevPeriod,
    onClick: disabled ? void 0 : onClick,
    disabled,
    children: /* @__PURE__ */ jsx(ArrowIcon, { disabled })
  }
);
export {
  PrevPeriod as default
};
